<template>
  <div>
    <div class="secdbanner"></div>
    <div class="section" style="min-height: 504px">
      <div class="crumbsModel">
        您现在的位置： <a :href="$store.state.home">首页</a>
        <a class="no-cache" href="https://cart.nstl.gov.cn">申请单</a>
      </div>
      <div class="section clearfix">
        <div class="techprocess">
          <ul class="clearfix">
            <li class="width400 active">
              <span><b>1</b>选择文献</span>
              <u></u>
            </li>
            <li class="width400">
              <span><b>2</b>确认支付</span>
              <u></u>
            </li>
            <li class="width400">
              <span><b>3</b>支付成功</span>
              <u></u>
            </li>
          </ul>
        </div>

        <div :class="appNull" id="emptyCart">
          <img src="../../../static/cart/img/cartEmpert.png" />
          <p>暂时没有申请单，现在去<a :href="$store.state.home">申请</a> 吧</p>
        </div>
        <div class="cartEmpert" v-show="loadingDivShow">
          <img src="../../../static/cart/img/loading.gif" />
        </div>
        <div :class="appTable">
          <table class="table">
            <thead>
              <tr>
                <th width="90px">
                  <label> <input type="checkbox" @click="checkAll()" v-model="checked" value="1" />全选</label>
                  <a @click="deleteRecord('all')" href="javascript:;">删除</a>
                </th>
                <th>申请文献</th>
                <th width="300px">服务单位</th>
                <th width="80px">页码</th>
                <th width="120px" v-show="showMoney">价格（元）</th>
                <th width="80px">删除</th>
              </tr>
            </thead>
            <tbody id="confirmation_order">
              <tr v-for="(d, index) in data.recordMap" :key="index" :id="d.recordId">
                <td>
                  <input type="checkbox" name="ck" :value="d.recordId" :ref="'ck' + d.recordId" v-model="docus" @change="getCartList()" />
                </td>
                <td>
                  <span class="text-align-left">
                    <p class="text-pramis font_12" style="text-align: left">
                      <a
                        class="text-pramis font_12"
                        :href="$store.state.home + '/paper_detail.html?id=' + d.recordId"
                        target="_blank"
                        :style="canOrderKeys.indexOf(d.recordId)==-1?'color: #909399; pointer-events: none;':''"
                        :title="canOrderKeys.indexOf(d.recordId)==-1?'该文献已下架，无法为您提供原文':''"
                        >{{ d.title }}</a
                      >
                      <span v-if="canOrderKeys.indexOf(d.recordId)==-1" title="该文献已下架，无法为您提供原文"><svg style="width: 14px;height: 14px;" t="1721800223942" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2608" width="200" height="200"><path d="M969.182003 701.303054C942.98583 761.818425 907.560805 814.394635 862.909139 859.030351 818.273423 903.682017 765.86402 939.121773 705.727336 965.303215 645.576031 991.515341 581.182839 1004.606061 512.545547 1004.606061 443.925315 1004.606061 379.349482 991.515341 318.818158 965.303215 258.302785 939.121773 205.726577 903.682017 161.090861 859.030351 116.439196 814.393527 80.999438 761.818425 54.817996 701.303054 28.605873 640.772838 15.515152 576.197117 15.515152 507.575665 15.515152 438.938373 28.605873 374.545181 54.817996 314.393878 80.999438 254.257304 116.439196 201.8479 161.090861 157.212073 205.726577 112.560409 258.302785 77.135381 318.818158 50.939208 379.349482 24.743034 443.925203 11.636364 512.545547 11.636364 581.182839 11.636364 645.576031 24.742924 705.727336 50.939208 765.8628 77.1366 818.273311 112.560409 862.909139 157.212073 907.560805 201.848897 942.984611 254.258412 969.182003 314.393878 995.378179 374.545181 1008.484848 438.938373 1008.484848 507.575665 1008.484848 576.197117 995.379287 640.772838 969.182003 701.303054L969.182003 701.303054Z" fill="#FF2E00" p-id="2609"></path><path d="M512 709.220647C472.332325 709.220647 440.203301 741.349668 440.203301 781.017346 440.203301 820.68502 472.332325 852.814044 512 852.814044 551.667675 852.814044 583.796699 820.68502 583.796699 781.017346 583.796699 741.349668 551.667675 709.220647 512 709.220647L512 709.220647Z" fill="#FFFFFF" p-id="2610"></path><path d="M512 639.709091C492.184111 639.709091 476.101651 606.196596 476.101651 564.820837L440.203301 227.823683C440.203301 186.447921 472.332325 152.935427 512 152.935427 551.667675 152.935427 583.796699 186.447921 583.796699 227.823683L547.898349 564.820837C547.898349 606.196596 531.815889 639.709091 512 639.709091L512 639.709091Z" fill="#FFFFFF" p-id="2611"></path></svg></span>
                      <span v-if="d.orderDate != null" id="spanundefined"><b class="shopplabel">已购买过</b></span>
                      <span v-if="d.flag" id="spanundefined"><b class="shopplabel">此篇文献已经超过了今天同类文献申请限制，您可以明天再申请</b></span>
                      <span class="none" id="spanundefined" :ref="'drainage' + d.recordId"><b class="drainageshopplabel">优惠免费</b></span>
                    </p>
                  </span>
                </td>
                <td>
                  <select :id="'library' + d.recordId" :ref="'library' + d.recordId" style="width: 170px" v-model="d.processUnit">
                    <option v-for="(lib, index) in d.libcode" :value="lib.libCode" :key="index">
                      {{ lib.libName }}
                    </option>
                  </select>
                </td>
                <td>
                  <span>{{ d.pageNumber }}</span>
                </td>
                <td id="identif" v-show="showMoney">
                  <span class="boldff6" :ref="'charge' + d.recordId">￥{{ d.preCharge.toFixed(2) }}</span>
                </td>
                <td>
                  <a @click="deleteRecord(d.recordId)" href="javascript:;">
                    <i class="iconfont icon-tubiaolunkuo-1"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div :class="appTable2">
          <div class="faxbox" id="delivery_methods" v-show="$store.state.isLogin">
            <div class="clearfix faxsinglebox">
              <!-- <span><em style="color: red">*</em>投递方式：</span>
              <select class="commonse se1" id="postType" onchange="changePostType(this);" v-model="data.transWay">
                <option value="M05">自助获取</option>
                <option value="M04">电子邮件</option>
              </select>-->
              <span><em style="color: red">*</em>电子邮件:</span>
              <input type="text" id="e_mail" size="30" maxlength="50" placeholder="请输入电子邮件!" @blur="validateEmail()" v-model="email" class="se1" />
              <span>手机号码:</span>
              <input type="text" id="e_phone" size="30" maxlength="50" placeholder="请输入手机号码!" v-model="phone" @blur="validateEmail()" />
            </div>
          </div>
          <div class="notesbfa" id="tip_info" v-show="$store.isLogin">
            <p>
              <i class="iconfont icon-zhu zhuicon"></i
              >注：自助获取方式，全文扫描完成后，系统将给用户发送电子邮件，用户通过电子邮件中的链接下载文献全文，也可以在“个人中心”-“申请查询”中自助下载。文件在服务器只保留15天，请及时查询下载。
            </p>
          </div>
          <!-- <div class="notesbfa fax_knomargin" id="tip1" style="border: none" v-show="$store.state.isLogin">
            <div class="faxbox">
              <div class="clearfix">
                <h4 class="paymodebox js_paymodebox">
                  支付方式：
                  <a>
                    <span :class="selectBalance" value="0" @click="changeActive('balance')">余额</span>
                  </a>
                  <a>
                    <span :class="selectBank" value="1" v-show="canBank" @click="changeActive('bank')">网上银行</span>
                  </a>
                  <a>
                    <span :class="selectWeiXin" value="2" v-show="canWeiXin" @click="changeActive('weixin')">扫码支付</span>
                  </a>
                </h4>
              </div>
            </div>
          </div> -->
          <div class="notesbfa" style="margin-top: 30px; color: red; font-size: 20px" v-show="!$store.state.isLogin">
            <span style="margin-left: 40px"><img src="../../../static/cart/img/nologin.png" style="width: 30px; margin-bottom: -5px"/></span>
            <span>您还未登录，去&nbsp;&nbsp;<a href="javascript:void(0)" @click="loginDialog" style="font-size: 20px">登录</a></span>
          </div>
          <!--<balance :style="balanceShow" :totalBalance="totalMoney" :totalPiece="totalCheck" :totalDiscountV="totalDiscount" @notes="notes" @loginDialog="loginDialog"></balance>
          <bank :style="bankShow" :totalBalance="totalMoney" :totalPiece="totalCheck" :totalDiscountV="totalDiscount" @notes="notes" @invoiceData="invoiceData" @loginDialog="loginDialog"></bank>
          	<keep-alive>
                        <router-view></router-view>
                    </keep-alive>-->
          <div class="notesbfa" id="tip2" style="border: none" v-show="$store.state.isLogin">
            <div class="faxbox">
              <div class="clearfix">
                <h4 class="userleaving">
                  用户留言：
                  <textarea id="remark" maxlength="200" v-model="userMemo"></textarea>
                </h4>
              </div>
            </div>
            <div v-show="tempTip" class="tempClass">
              温馨提示: 服务单位中国科学院文献情报中心将于2025年7月11日17:00至12日暂停全文传递服务，在此期间提交的中国科学院文献情报中心订单将于7月13日按序处理，请您在申请时慎重考虑。已申请订单可在“个人中心”取消。
            </div>
          </div>
          <div class="notesbfa" style="border: none;" v-show="chunjie">
            <div class="faxbox">
              <div class="clearfix">
                <h4 class="userleaving" style="color: red;font-size: 20px;">
                  <!-- 温馨提示： 因春节放假，2月9日至17日期间暂停处理全文传递、参考咨询及400电话应答。在此期间您可以正常提交申请，申请单将在18日开始恢复处理。 -->
                  温馨提示：服务单位“中国农业科学院农业信息研究所”于5月18日至19日暂停原文传递服务。在此期间无法及时进行全文传递，请您在申请时慎重考虑。
                </h4>
              </div>
            </div>
          </div>
          <div class="Receaddress" id="tip3">
            <div class="invoice_sendwithgift">
              <span id="sec_count"><b>已选文献：</b>{{ totalCheck }}篇</span>
              <span id="sec_discount" v-show="false"><b>已优惠：</b>￥{{ totalDiscount }}</span>
              <span id="total_money" v-show="showMoney"><b>总计：</b>￥{{ totalMoney }}</span>
              <a @click="submit()" class="btn-1 js_btn_1" href="javascript:;" :style="$store.state.isLogin ? '' : 'background-color: #b9b4b1;'">提交申请 </a>
              <!-- <a href="/" class="btn-2">取消</a> -->
            </div>
          </div>

          <div class="maskbg js_letterment" :style="tipsStyle">
            <div class="masktips maskshopping">
              <p class="masktitle"><span>用户承诺书</span><i class="close iconfont icon-cuo fr" @click="cancel()"></i></p>
              <div class="lettermentbox">
                <div class="lettermentcont">
                  <p>
                    我承诺在使用国家科技图书文献中心文献提供服务时，遵守《中华人民共和国著作权法》及相关政策法规。所申请的文献仅限于个人学习和研究使用，不向公共网络平台和第三方机构传递通过NSTL网络服务系统获得的文献。
                  </p>
                  <p>在申请文献过程中，遵守NSTL关于文献传递的用途、数量等的规定。如果超出此范围提出文献传递请求或者传递文献，当被判定侵犯著作人合法权益后，愿意承担相应的法律责任。</p>
                </div>
                <div class="checkboxbox">
                  <label><input type="checkbox" v-model="confirmTips" value="1" id="next_agree" />我已认真阅读上述声明，并接受声明的所有内容。</label>
                </div>
                <div class="maskbtn">
                  <a class="btns btns-pramis" id="next_tip" @click="next()" href="javascript:;">下一步</a>
                  <a class="btns disable" id="cancle" @click="cancel()" href="javascript:;">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="完善手机号" :visible.sync="dialogFormVisible" custom-class="dialogClass" :close-on-click-modal="false">
      <div class="phoneTips">
        <font>为了更好的为您服务，请您先完善手机号信息。</font>
      </div>
      <el-form>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-input v-model="mobilePhone" autocomplete="off" placeholder="请输入手机号" maxlength="11" @blur="getPc()"></el-input>
        </el-form-item>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-input v-model="msgCode" placeholder="请输入短信验证码" style="width: 60%" maxlength="6"></el-input>
          <el-button id="sendCodeButton" style="float: right" v-bind:disabled="codeButtonAble">{{ getCodeText }}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="registExternal(0)">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="检测到手机号已注册用户" :visible.sync="dialogTableVisible" custom-class="dialogClass" :close-on-click-modal="false">
      <!-- 未用到，暂时保留，目前该流程取消 -->
      <el-row style="line-height: 40px">
        <el-col style="width: 30%">用户姓名：</el-col>
        <el-col style="width: 70%">{{ hasBindUser.bindUserName }} <el-input v-model="rendUserName" placeholder="请补全用户名" style="width: 60%" label-width="120px"></el-input></el-col>
      </el-row>
      <el-row style="line-height: 90px">
        <el-col style="width: 30%">注册站点：</el-col>
        <el-col style="width: 70%">
          <el-select v-model="rendLibCode" placeholder="请选择站点">
            <el-option :value="lib.code" v-for="lib in $store.state.libInfo" :key="lib.code" :label="lib.name"></el-option>
          </el-select>
        </el-col>

        <!--<el-col style="width: 50%;">{{hasBindUser.bindUserLibName}}</el-col>-->
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="registExternal(1)">绑 定</el-button>
        <el-button type="primary" @click="registExternal(2)">注 册</el-button>
      </div>
    </el-dialog>
    <div v-show="false">
      <iframe :src="reLoginUrl" width="0" height="0" id="benefitnotice_iframe"></iframe>
    </div>
    <div id="mpanel2"></div>
  </div>
</template>
<style>
.dialogClass {
  width: 400px !important;
}
</style>
<script>
import Pubsub from 'pubsub-js'
import balance from './Balance'
import bank from './Bank'
/**
 * cookie说明
 * C:购物车数量
 * cartnlg:购物车内articleId集合
 */
export default {
  components: {
    balance,
    bank
  },
  data() {
    return {
      chunjie: false, //春节处理提示
      appConfirm: 'borderbtom result_area hide',
      appNull: 'cartEmpert hide',
      appTable: 'tables result_area hide',
      appTable2: 'notesdetailed result_area hide',

      loadingDivShow: true, //购物车加载中动态
      tipsStyle: 'display:none', //确认提交弹出框
      confirmTips: [], //弹出框阅读声明付线框
      // userTypeCanBank: false, //用户类型是否可以网银支付
      // userTypeCanWeiXin: false, //用户类型是否可以微信支付
      // canBank: false, //是否可以网银支付
      // canWeiXin: false, //是否可以微信支付
      //  selectBalance: '', //余额支付选中样式
      //  balanceShow: '', //显示余额支付
      //  selectBank: '', //网银支付选中样式
      //  selectWeiXin: '', //微信支付选中样式
      //   bankShow: 'display:none', //显示网银支付
      totalMoney: 0, //选中的总金额
      totalCheck: 0, //选中文献总数
      totalDiscount: 0, //优惠金额
      checked: [], //全选
      showMoney: true,
      email: '', //邮箱
      phone: '', //手机号码
      userMemo: '', //备注
      invoice: {}, //发票信息
      //选中的购物车ID
      docus: [], //选中的文献id集合
      isLogin: false,

      sendCodeCount: 0, //发送短信验证码次数
      mobilePhone: '', //手机号
      msgCode: '', //验证码
      dialogFormVisible: false, //弹出框
      dialogTableVisible: false,
      codeButtonAble: false,

      getCodeText: '获取验证码',
      formLabelWidth: '1px',
      reLoginUrl: '', //重新登录地址
      rendLibCode: '',
      rendUserName: '',
      hasBindUser: {
        bindUserId: '',
        bindUserName: ''
      },

      //购物车数据
      data: {
        directOrderNum: null,
        discountValue: 0,
        issueIdMap: {}, //此处不确定是数组还是对象，若issueIdMap中需要放多个对象需改为数组 []
        orderNum: 0,
        preCharge: 0,
        recordMap: [],
        recordNum: 0,
        transWay: 'M05',
        userId: '',
        userStar: ''
      },
      canOrderKeys:[],
      banArray: [],
      tempTip: true,
    }
  },
  methods: {
  
    loginDialog() {
      this.$emit('nstlUserLogin')
    },

    init() {
      let userInfo = this.$store.state.userInfo
      if (userInfo != null && userInfo != undefined) {
        if (userInfo.email && !this.email) {
          this.email = userInfo.email
        }
        if (userInfo.mobilephone && !this.phone) {
          this.phone = userInfo.mobilephone
        }
        const isExternal = this.$store.state.isExternal
        if (this.$store.state.userInfo.userAuth == 'VIP特许'||isExternal) {
          this.showMoney = false
        }
        //判断用户是否可以进行网银支付
        /*  if (userInfo.userlibcode == 'CN000000' && (userInfo.usertype == '普通用户' || userInfo.usertype == '西部用户')) {
          this.userTypeCanBank = true
        } */
        //微信支付显示
        //this.userTypeCanWeiXin = true
        /*  if ((userInfo.usertype == '普通用户' || userInfo.usertype == '西部用户') && userInfo.userlibcode == 'CN000000') {
          this.userTypeCanWeiXin = true
        } */

        //
        // if (userInfo.userlibcode != 'CN000000' && (userInfo.usertype == '普通用户' || userInfo.usertype == '西部用户')) {
        //   this.userTypeCanWeiXin = true
        //  }
      }
    },
    //购物车是否为空状态切换
    changeStatus() {
      if (Object.keys(this.data.recordMap).length == 0) {
        this.appConfirm = 'borderbtom result_area hide'
        this.appNull = 'cartEmpert'
        this.appTable = 'tables result_area hide'
        this.appTable2 = 'notesdetailed result_area hide'
      } else {
        this.appConfirm = 'borderbtom result_area'
        this.appNull = 'cartEmpert hide'
        this.appTable = 'tables result_area'
        this.appTable2 = 'notesdetailed result_area'
      }
    },

    //获取购物车列表
    getCartList() {
      let recordList = new Array()
      //封装一个recordList，记录哪些id被选中(页面第一次加载时无此值),为了修改购物车内的选中状态

      if (Object.keys(this.data.recordMap).length > 0) {
        for (let key in this.data.recordMap) {
          if (this.docus.indexOf(key) != -1) {
            recordList.push({ recordId: key, checked: true })
          } else {
            recordList.push({ recordId: key, checked: false })
          }
        }
      }
      this.$http.post('/cart/getCartList.shtml?t=' + Math.random(), recordList).then(response => {
        this.docus = []
        this.loadingDivShow = false

        if (response.data.data.data != null) {
          let cartnlg = ''
          this.canOrderKeys = response.data.data.keys  //可订购的文献ID列表
          this.data = response.data.data.data
         
          for (var key in this.data.recordMap) {
            //记录已加入购物车文献id，文献列表反显
            cartnlg += key + ','
            //this.canOrderKeys.push(key) //这里临时添加，正式上线时徐亚戳恢复上面395行的内容，并删除本行的内容
            //判断加工单位是否正确
            // 如果加工单位存在于馆藏单位，则默认选择加工单位为服务单位+
            let processUnit = this.data.recordMap[key].processUnit

            let libs = this.data.recordMap[key].libcode

            var f = false
            let newlibs = new Array()
            for (var index = 0; index < libs.length; index++) {
              //农科临时封禁
              /*if(libs[index].libCode!='CN111023'){
                newlibs.push(libs[index])
              }*/
              /* var startTime = new Date('2025-03-14 16:00:00').getTime()
              var endTime = new Date('2025-03-17 23:59:59').getTime()
              var now = new Date().getTime() */
             // 中科临时封禁结束
              // if(libs[index].libCode === 'CN311001' && startTime <= now && now <= endTime){
                // 添加前检查是否存在
                // if (!this.banArray.includes(key)) {
                  // this.banArray.push(key);
                // }
              // }
              //农科临时封结束
              if (libs[index].libCode == processUnit) {
                f = true
              }
            }
            if (!f) {
              //如果加工单位不正确，则默认设置第一个
              this.data.recordMap[key].processUnit = libs[0].libCode
            }

            //农科临时封禁
            /*if(newlibs.length>0){
              this.data.recordMap[key].libcode = newlibs;
              if(this.data.recordMap[key].processUnit=='CN111023'){
                this.data.recordMap[key].processUnit = newlibs[0].libCode
              }
            }*/

            //农科临时封结束
          }
          //console.log(JSON.stringify(this.data))
          cartnlg = cartnlg.substring(0, cartnlg.length - 1)
          this.$cookie.set('cartnlg', cartnlg, { expires: '1Y', path: '/', domain: '.nstl.gov.cn' })

          sessionStorage.setItem('token', response.data.data.token)
          for (var key in this.data.recordMap) {
            if (this.data.recordMap[key]['checked']) {
              this.docus.push(key)
            }
          }
          //localStorage.setItem("cartnlg",cartnlg)
        } else {
          this.data = { recordMap: [] }
        }
        //发送购物车数量广播
        // this.$cookie.set("C",Object.keys(this.data.recordMap).length,{expires: "1Y",path:"/",domain:".nstl.gov.cn"})
        Pubsub.publish('cartCount', Object.keys(this.data.recordMap).length)
        this.changeStatus()
      })
    },

    //通过所选的文献id，从data.recodeMap中删除
    deleteRecord(recordId) {
      var articleIds = []
      let msg = '确定要删除选中的文献吗?'
      if (recordId == 'all') {
        //删除所有
        articleIds = this.docus
      } else {
        articleIds.push(recordId)
        msg = '确定要删除该文献吗?'
      }
      let that = this
      if (articleIds.length == 0) {
        this.$message.alert('请选择要删除的文献！', '信息')
        return false
      }
      this.$message
        .confirm(msg, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          center: false
        })
        .then(() => {
          this.$http
            .post(
              '/cart/delCart.shtml',
              this.$queryString.stringify({
                articleIds: articleIds,
                transWay: that.data.transWay
              }),
              {
                emulateJSON: true
              }
            )
            .then(response => {
              if (response.data.code == 0) {
                this.getCartList()
              } else {
                this.$message.alert(response.data.msg, '信息')
              }
            })
        })
    },

    //切换支付方式
    /* changeActive(path) {
      if (path == 'bank') {
        this.selectBank = 'active'
        this.selectBalance = ''
        this.selectWeiXin = ''
        this.bankShow = ''
        this.balanceShow = 'display:none'
      } else if (path == 'balance') {
        this.selectBank = ''
        this.selectBalance = 'active'
        this.selectWeiXin = ''
        this.bankShow = 'display:none'
        this.balanceShow = ''
      } else if (path == 'weixin') {
        this.selectBank = ''
        this.selectWeiXin = 'active'
        this.selectBalance = ''
        this.bankShow = ''
        this.balanceShow = 'display:none'
      }
    }, */

    //全选按钮
    checkAll() {
      if (this.checked == '') {
        for (var key in this.data.recordMap) {
          this.docus.push(key)
        }
      } else {
        this.docus = []
      }
      this.getCartList()
    },

    //提交时下一步
    next() {
      if (this.docus.length == 0) {
        this.$message.alert('请选择文献后再提交!', '信息')
        return false
      }

      //点击下一步 发送请求进入下一个页面
      //选中的购物车数据
      let cartOrderVo = {
        transWay: this.data.transWay,
        email: this.email,
        phone: this.phone,
        userMemo: this.userMemo,
        recordList: []
      }
      if (this.confirmTips.length == 1) {
        this.tipsStyle = 'display:none'
        for (var i = 0; i < this.docus.length; i++) {
          let articleId = this.docus[i]
          if(this.canOrderKeys.indexOf(articleId)==-1){

              continue;
          }
          let libraryCode = this.$refs['library' + articleId][0].value

          let record = {
            libraryLibCode: libraryCode,
            articleId: articleId
          }

          cartOrderVo.recordList.push(record)
        }
        if (cartOrderVo.recordList.length == 0) {
          this.$message.alert('请选择文献后再提交!', '信息')
          return false
        }
        let that = this
        $('.js_btn_1').addClass('disable')
        setTimeout(function() {
          $('.js_btn_1').removeClass('disable')
        }, 3000)
        this.$loading.show()
        this.$http.post('/cart/submitOrder.shtml?token=' + sessionStorage.getItem('token'), cartOrderVo).then(response => {
          sessionStorage.removeItem('token')
          this.$loading.hide()

          if (response.data.code == 2) {
            //需要完善信息
            // TODO
            this.dialogFormVisible = true
          } else if (response.data.code != 0) {
            this.$message.alert(response.data.msg, '信息')
          } else {
            that.tipsStyle = 'display:none'
            if (this.selectBalance == 'active' || this.invoice.invoiceType == '0') {
              this.invoice = {}
            }

            //记录现在购物车内的文献id，前台列表页购物车按钮
            try {
              let cartnlg = decodeURIComponent(this.$cookie.get('cartnlg'))
              for (var i = 0; i < this.docus.length; i++) {
                cartnlg = cartnlg.replace(this.docus[i] + ',', '')
                cartnlg = cartnlg.replace(this.docus[i], '')
                this.$cookie.set('cartnlg', cartnlg, { expires: '1Y', path: '/', domain: '.nstl.gov.cn' })
              }
            } catch (err) {
              console.log('更新cartnlg错误')
            }

            //更新购物车数量

            Pubsub.publish('cartCount', Object.keys(this.data.recordMap).length - this.docus.length)
            //发送请求进入下一个页面
            // localStorage.setItem('invoice', JSON.stringify(this.invoice))
            // TODO 删除tl内提交成功的articleId，重新设置cookie

            /*this.$http.get('/cart/validateUser.shtml').then((response) => {
              if (response.data.data) {
                this.$store.commit('setDrainage', response.data.data.flag)
                this.$store.commit('setArticleCount', response.data.data.dcount)
              }
            })*/
            const isExternal = this.$store.state.isExternal
            if (this.$store.state.userInfo.userAuth == 'VIP特许'||isExternal) {
              this.balancePay(response.data.data)
            } else {
              this.$router.push({
                name: 'Pay',
                query: { orderId: response.data.data }
              })
            }
          }
        })
      } else {
        this.$message.alert('请阅读上述声明，并接受声明的所有内容', '信息')
      }
    },
    //  取消提交
    cancel() {
      this.tipsStyle = 'display:none'
    },
    //校验email格式
    validateEmail() {
      let patt = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      let phoneReg = /^1\d{10}$/
      if (this.email == null || this.email.length == 0 || this.email.length > 50) {
        this.$message.alert('电子邮件不能为空并且长度不超过50个字符！', '信息')
        return false
      }
      if (!patt.test(this.email)) {
        this.$message.alert('邮箱格式填写不正确，请填写正确的邮箱信息！', '信息')
        return false
      }
      if (this.phone && this.phone.length > 0) {
        if (!phoneReg.test(this.phone)) {
          this.$message.alert('手机号填写不正确，请填写正确的手机号！', '信息')
          return false
        }
      }
      return true
    },
    /*  notes(val) {
      //用户备注，子传父
      this.userMemo = val
    },
    invoiceData(val) {
      //发票信息，子传父
      this.invoice = val
    }, */

    //文献类型是否为优惠类型（未使用）
    isArticleDrainage: function(articeId) {
      if (Object.keys(this.data.recordMap).length > 0) {
        let articleData = this.data.recordMap[articeId]
        let articleType = articleData['sysSubType']
        let clc = articleData['clc']
        let entityType = articleData['entityType']
        let language = articleData['language']
        let accessType = articleData['accessType']
        if (articleType == 'Z01') {
          if (!clc) {
            return true
          } else {
            let clcArr = clc.split(';')
            for (let i = 0; i < clcArr.length; i++) {
              if (clcArr[i].startsWith('B') || clcArr[i].startsWith('C') || clcArr[i].startsWith('D') || clcArr[i].startsWith('F') || clcArr[i].startsWith('G')) {
                return false
              }
            }
            return true
          }
        } else if ('JournalPaper' == entityType) {
          if ('英语' == language && ('nstl' == accessType || 'NSTL' == accessType)) {
            return true
          }
        }
      }
      return false
    },
    //是否显示优惠标志 (未使用)
    drainageDiscount() {
      let userInfo = this.$store.state.userInfo
      let hasDiscountCount = this.$store.state.articleCount
      // let tl = this.$cookie.get('tl')
      //let tl = 'U0UFp9mdiPVmrqKs7dQaRXVU4u960socMiQ7IqnMZASTfs23jl+qLudNc0zfg1OvOK64yKhdVptMdLGMO4JrEgU09mMcrkPGh3UztBoVcP8='
      //2a722af0111b65e224fe7ff887215fbe_b,148e9aafb188fa597d8961d7dabcb41b_b
      //  if (tl) {
      //  tl = crypto.decrypt(tl)
      let that = this
      this.docus.forEach(function(key) {
        let isDrui = false
        if (that.data.recordMap[key]['drainage'] && that.$store.state.isDrainage && that.isArticleDrainage(key) && hasDiscountCount > 0) {
          isDrui = true
          hasDiscountCount--
        }
        if (!userInfo && that.data.recordMap[key]['drainage'] && that.isArticleDrainage(key)) {
          isDrui = true
        }
        if (that.$refs['drainage' + key] && isDrui) {
          that.$refs['drainage' + key][0].classList.remove('none')
          that.$refs['drainage' + key][0].classList.add('block')
          that.$refs['charge' + key][0].innerHTML = '￥0.00'
        } else if (that.$refs['drainage' + key]) {
          that.$refs['drainage' + key][0].classList.remove('block')
          that.$refs['drainage' + key][0].classList.add('none')
          that.$refs['charge' + key][0].innerHTML = '￥' + that.data.recordMap[key]['preCharge'].toFixed(2)
        }
      })
      for (var key in this.data.recordMap) {
        if (this.docus.indexOf(key) == -1) {
          let isDrui = false
          if (that.data.recordMap[key]['drainage'] && that.$store.state.isDrainage && that.isArticleDrainage(key) && hasDiscountCount > 0) {
            isDrui = true
            hasDiscountCount--
          }
          if (!userInfo && that.data.recordMap[key]['drainage'] && that.isArticleDrainage(key)) {
            isDrui = true
          }
          if (that.$refs['drainage' + key] && isDrui) {
            that.$refs['drainage' + key][0].classList.remove('none')
            that.$refs['drainage' + key][0].classList.add('block')
            that.$refs['charge' + key][0].innerHTML = '￥0.00'
          } else if (that.$refs['drainage' + key]) {
            that.$refs['drainage' + key][0].classList.remove('block')
            that.$refs['drainage' + key][0].classList.add('none')
            that.$refs['charge' + key][0].innerHTML = '￥' + that.data.recordMap[key]['preCharge'].toFixed(2)
          }
        }
      }
      //  }
    },
    //发送短信验证码
    sendMsgCode(vc) {
      let phoneReg = /^1\d{10}$/
      if (!phoneReg.test(this.mobilePhone)) {
        this.$message.alert('手机号格式不正确,请填写正确的手机号', '信息')
        return
      }
      this.codeButtonAble = true
      let pram = {
        mobilePhone: this.mobilePhone,
        vc: vc
      }
      this.$http
        .post('/cart/smc.shtml', this.$queryString.stringify(pram))
        .then(response => {
          if (response.data.data) {
            this.sendCodeCount = response.data.data
          }

          if (response.data.code == 0) {
            this.restMsgCode(60)
          } else {
            this.codeButtonAble = false
          }
          this.$message.alert(response.data.msg, '信息')
        })
        .catch(() => {
          console.log('发送验证码失败')
          this.codeButtonAble = false
        })
    },
    //获取验证码按钮倒计时
    restMsgCode(t) {
      this.getCodeText = t + 's后重发'
      if (t <= 0) {
        this.codeButtonAble = false
        this.getCodeText = '获取验证码'
      } else {
        let that = this
        setTimeout(function() {
          that.restMsgCode(--t)
        }, 1000)
      }
    },
    handleChangeCheckCode() {
      this.randCodeImage = ''
    },
    //第三方账号注册
    registExternal(bind) {
      let phoneReg = /^1\d{10}$/
      if (!phoneReg.test(this.mobilePhone)) {
        this.$message.alert('手机号格式不正确,请填写正确的手机号', '信息')
        return
      }
      if (this.msgCode == '') {
        this.$message.alert('请输入验证码!', '信息')
        return
      }

      /*  if(bind==1){  //绑定
        if(!this.hasBindUser.bindUserName){
          this.$message.alert('用户名为空，如需绑定请 <a style="font-size:14px" href="https://anyask.nstl.gov.cn/ask/" target="_blank">联系管理员</a>', '信息',{dangerouslyUseHTMLString:true});
          return;
        }
        if(!this.rendUserName){
          this.$message.alert('请补全用户名!', '信息');
          return;
        }
        if(!this.rendLibCode){
          this.$message.alert('请选择站点!', '信息');
          return;
        }
      }
 */
      let pram = {
        isBind: bind,
        mobilePhone: this.mobilePhone,
        phoneCode: this.msgCode,
        rendUserName: this.rendUserName,
        rendLibCode: this.rendLibCode
      }

      this.$http.post('/cart/registExternal.shtml', this.$queryString.stringify(pram)).then(response => {
        if (response.data.code == 0) {
          if (response.data.data == null) {
            this.dialogFormVisible = false
            this.dialogTableVisible = false

            this.$cookie.set('user_isBind', null, { expires: '-1', path: '/', domain: '.nstl.gov.cn' })
            this.$message.alert(response.data.msg, '信息').then(() => {
              if (this.$store.state.userInfo.isbind == '0') {
                const iframe = document.querySelector('#benefitnotice_iframe')
                iframe.onload = function() {
                  location.reload()
                }
                this.reLoginUrl = 'https://login.nstl.gov.cn/externalLogin?op=relogin'
              } else {
                location.reload()
              }
            })
          } else {
            this.dialogTableVisible = true
            this.hasBindUser = response.data.data
          }
        } else {
          this.$message.alert(response.data.msg, '信息')
        }

        console.log(response)
      })
    },

    /**行为验证码 */
    captcha() {
      $('#mpanel2').addClass('t')
      let that = this
      $('#mpanel2').slideVerify({
        baseUrl: 'https://login.nstl.gov.cn', //服务器请求地址, 默认地址为安吉服务器;
        mode: 'pop', //展示模式
        containerId: 'sendCodeButton', //pop模式 必填 被点击之后出现行为验证码的元素id
        imgSize: {
          //图片的大小对象,有默认值{ width: '310px',height: '155px'},可省略
          width: '400px',
          height: '200px'
        },
        barSize: {
          //下方滑块的大小对象,有默认值{ width: '310px',height: '50px'},可省略
          width: '400px',
          height: '40px'
        },
        beforeCheck: function() {
          //  return true
          //检验参数合法性的函数  mode ="pop"有效
          // var flag = true;
          // //实现: 参数合法性的判断逻辑, 返回一个boolean值
          // return flag
          if (that.sendCodeCount >= 3) {
            $('html').addClass('captchaAction')
            return true
          } else {
            that.sendMsgCode()
            return false
          }
        },
        afterCheck: function() {
          $('html').removeClass('captchaAction')
        },
        ready: function() {
          console.log('jiazile')
        }, //加载完毕的回调
        success: function(params) {
          $('html').removeClass('captchaAction')
          //成功的回调
          that.sendMsgCode(params.captchaVerification)
          // params为返回的二次验证参数 需要在接下来的实现逻辑回传服务器
          // 例如: login($.extend({}, params))
        },
        error: function() {
          //$("html").removeClass("captchaAction")
        } //失败的回调
      })
    },

    /**
     * 获取发送短信次数
     */
    getPc() {
      let that = this
      this.$http.get('/cart/getPc.shtml?mobilePhone=' + this.mobilePhone).then(response => {
        that.sendCodeCount = response.data.data
      })
    },
    /** */
    hasBound() {
      if (
        this.$store.state.userInfo.isbind == '0' ||
        ((this.$store.state.userInfo.usertype == '普通用户' || this.$store.state.userInfo.usertype == '西部用户') && !this.$store.state.userInfo.bindphone)
      ) {
        //  if (this.$store.state.userInfo.isbind == '0') {

        this.dialogFormVisible = true
        this.$nextTick(function() {
          if (!$('#mpanel2').hasClass('t')) {
            this.captcha()
          }
        })
        return false
      }
    },
    /**提交 */
    submit() {
      if ($('.js_btn_1').hasClass('disable')) {
        return
      }
      if (!this.$store.state.isLogin) {
        this.$emit('nstlUserLogin')
      } else {

        if (this.docus.length == 0) {
          this.$message.alert('请选择文献后再提交!', '信息')
          return false
        }
        // 去掉中科临时封禁
        /* if (this.banArray.length > 0) {
           // 新增判断
          if (this.docus.some(item => this.banArray.includes(item))) {
            for (let index = 0; index < this.docus.length; index++) {
              const libraryCode = this.$refs['library' + this.docus[index]][0].value
              if(libraryCode === "CN311001"){
                this.$message.alert('受施工改造断电影响，3月14日16时至17日中科馆藏文献暂停全文传递服务，请更换其他馆藏！', '提示');
                return;
              }
            }
          }
        } */
        let length = this.docus.length
        //循环docus，判断元素是否在canOrderKeys中，如果不存在，则从docus中移除元素
        for (let i = 0; i < this.docus.length; i++) {
          if (this.canOrderKeys.indexOf(this.docus[i]) == -1) {
            this.docus.splice(i, 1)
            i--
          }
        }
        if(this.docus.length==0){
            this.$message.alert('您选择的文献已经下架，无法提供原文，请重新选择文献提交!', '信息')
            return false
        }else if(length>this.docus.length){
            this.$message.alert('您选择的文献中存在已下架的文献，提交时将不包含该文献!', '信息')
        }
        if (
          this.$store.state.userInfo.isbind == '0' ||
          ((this.$store.state.userInfo.usertype == '普通用户' || this.$store.state.userInfo.usertype == '西部用户') && !this.$store.state.userInfo.bindphone)
        ) {
          //  if (this.$store.state.userInfo.isbind == '0') {
          this.dialogFormVisible = true
          this.$nextTick(function() {
            if (!$('#mpanel2').hasClass('t')) {
              this.captcha()
            }
          })
        } else {
          if (this.validateEmail()) {
            this.tipsStyle = '' //弹出提示
          }
        }
      }
    },
    //余额支付
    balancePay: function(orderId) {
      this.$http
        .post('/cart/balancePay.shtml', this.$queryString.stringify({ orderId: orderId }), {
          emulateJSON: true
        })
        .then(response => {
          this.$loading.hide()
          if (response.data.code == 0) {
            this.$router.push('success')
          } else {
            this.$router.push({
              name: 'fail',
              params: { payResponse: JSON.stringify(response.data), orderId: orderId }
            })
          }
        })
    }
  },
  mounted() {
    var startTime = new Date('2024-05-17 00:00:00').getTime()
    var endTime = new Date('2024-05-20 00:00:00').getTime()
    var now = new Date().getTime()
    if (startTime <= now && now <= endTime) {
      this.chunjie = true
    }
    var zkEndTime = new Date('2025-07-12 23:59:59').getTime()
    if(zkEndTime <= now){
      this.tempTip = false 
    }

    let that = this
    let urlParams = new URLSearchParams(location.search)
    let id = urlParams.get('id')
    if (id) {
      this.$http.get('/cart/addCart.shtml?id=' + id).then(response => {
        if (response.data.code == 3) {
          this.$message
            .confirm('当前文献不可订购，是否通过代查代借获取原文？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning',
              center: false
            })
            .then(() => {
              location.href = that.$store.state.home + '/agent_buy_info.html?id=' + id
            })
            .catch(() => {
              location.href = '/cart/select'
            })
        } else {
          location.href = '/cart/select'
        }
      })
    }

    /*    Pubsub.subscribe('submitOrder', (name, context) => {
      if (this.docus.length == 0) {
        this.$message.alert('请选择文献后再提交!', '信息')
        return false
      }
      if (this.$store.state.userInfo.isbind == '0') {
        this.dialogFormVisible = true
        this.$nextTick(function () {
          if (!$('#mpanel2').hasClass('t')) {
            this.captcha()
          }
        })
      } else {
        if (this.validateEmail()) {
          this.tipsStyle = '' //弹出提示
        }
      }
    }) */
    Pubsub.subscribe('uover', (name, context) => {
      this.getCartList()
      // this.changeActive('balance')
    })

    this.getCartList()
    // this.changeActive('balance')
  },
  watch: {
    /* "data.recordMap":function(){
      let that = this;
      this.$nextTick(() => {
      // 可以使用回调函数的写法
      // 这个函数中DOM必定渲染完成
       //农科临时封结束
      for (let key in this.data.recordMap) {
       if($("#"+key).find("select").val()=='CN111023'){
        $("#"+key).find("input[type='checkbox']").attr("checked",false);
        $("#"+key).find("input[type='checkbox']").attr("disabled",true);
        that.docus = that.docus.filter(t=>t!=key)
      }
        }
    })
    },*/
    docus: function(value) {
      this.init()
      //监控选择的文献
      if (value.length == Object.keys(this.data.recordMap).length) {
        this.checked = [1]
      } else {
        this.checked = []
      }
      this.totalCheck = value.length
      this.totalMoney = 0
      this.totalDiscount = 0

      let userInfo = this.$store.state.userInfo
      let hasDiscountCount = this.$store.state.articleCount
      for (let i = 0; i < value.length; i++) {
        /**if (
          (this.data.recordMap[value[i]]['drainage'] && this.$store.state.isDrainage && this.isArticleDrainage(value[i]) && hasDiscountCount > 0) ||
          (this.data.recordMap[value[i]]['drainage'] && !userInfo)
        ) {
          this.totalDiscount += this.data.recordMap[value[i]]['preCharge']
          hasDiscountCount--
        } else {*/
        this.totalMoney += this.data.recordMap[value[i]]['preCharge']
        // }
      }
      this.totalMoney = this.totalMoney.toFixed(2)
      // this.totalDiscount = this.totalDiscount.toFixed(2)
      /*    if (this.totalMoney == 0) {
        //文献金额为0不能使用网银支付
        this.canBank = false
        this.canWeiXin = false
        this.changeActive('balance')
      } else {
        this.canBank = this.userTypeCanBank
        this.canWeiXin = this.userTypeCanWeiXin
      } */
      //this.getCartList()
    }
  },
  updated() {
    // this.drainageDiscount()
  }
}

Array.prototype.remove = function(v) {
  let flag = false
  for (let i = 0; i + 1 < this.length; i++) {
    if (this[i] == v) {
      flag = true
    }
    if (flag) {
      this[i] = this[i + 1]
    }
  }
  if (flag) {
    this.length -= 1
  }
}
</script>
<style scoped>
.none {
  display: none;
}

.block {
  display: inline;
}

.phoneTips {
  min-height: 45px;
  font-size: 15px;
  color: red;
}

.drainageshopplabel {
  display: inline-block;
  height: 20px;
  border-radius: 10px;
  border: 1px solid red;
  padding: 0 12px;
  margin-left: 7px;
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: red;
}
.tempClass {
  color: red;
  font-size: 17px;
  margin-top: 10px;
}
</style>
<style>
#mpanel2 .mask {
  opacity: 1;
  z-index: 3000;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>



// WEBPACK FOOTER //
// src/views/cart/Select.vue